import "./css/app.scss";
import "./ts/neto.js";


import lazyLoad from "./ts/lazyLoad";
import loadSprite from "./ts/loadSprite";
import slider from './ts/slider';
import { addEvent, appHeight, heightChange } from "./ts/utils";
import accordian from "./ts/accordian";
import mobMenu from "./ts/mobMenu";
import dropdown from "./ts/dropdowns";
import descMenu from "./ts/descMenu";
import stickyHeader from "./ts/stickyHeader";
import finder from "./ts/finder";
import readMore from "./ts/readmore";
import cartLine from './ts/cartLine';
import sidebar from "./ts/sidebar";
import specificDropdown from "./ts/specificDropdown";
import showHide from "./ts/showHidePagination";

addEvent();
appHeight();
heightChange();
loadSprite.init();
lazyLoad.init();
cartLine.init();
slider.init();
accordian.init();
mobMenu.init()
dropdown.init();
descMenu.init();
stickyHeader.init();
// finder.init();
readMore.init();
sidebar.init();
showHide.init();
specificDropdown.init();





